import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import LoginRequired from '../../pages/LoginRequired/LoginRequired';

/**
 * ProtectedRoute komponenten beskytter ruter der kræver authentication.
 * 
 * @component
 * @description
 * Tjekker om brugeren er logget ind. Hvis ja, vises den beskyttede komponent.
 * Hvis nej, vises LoginRequired komponenten i stedet.
 * 
 * @param {Object} props - Komponent props
 * @param {React.Component} props.children - Komponenten der skal beskyttes
 * @param {string} [props.requiredPage] - Sidenøgle i pageAccess der kræves for adgang
 * @returns {JSX.Element} Enten den beskyttede komponent eller LoginRequired
 */
const ProtectedRoute = ({ children, requiredPage }) => {
  const user = useSelector((state) => state.mate.currentUser);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const token = useSelector((state) => state.auth.token);
  
  // Tjek både authentication state og om vi har en bruger
  const isLoggedIn = isAuthenticated && !!token && !!user;

  if (!isLoggedIn) {
    return <LoginRequired />;
  }

  if (requiredPage && user?.role !== 'admin') {
    const userPageAccess = user?.pageAccess || [];
    if (!userPageAccess.includes(requiredPage)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
